import { Cart } from "@commercetools/platform-sdk"
import * as Sentry from "@sentry/browser"
import { parseCookies } from "nookies"
import { CartService } from "../../../cart/CartService"
import { createLogger } from "../../../utils/createLogger"
import { CartValidationBase, cartSuccess } from "../../validation/FormValidator"
import { CartValidationResult } from "../../validation/ValidationError"
import { combineGAValuesIntoCustomData } from "../GAValues"

const logger = createLogger("GACustomDataValidation")

export class GACustomDataValidation extends CartValidationBase {
  private cartService: CartService
  constructor(cartService: CartService) {
    super("GACustomDataValidation")
    this.cartService = cartService
  }

  save(c: Cart): CartValidationResult {
    return combineGAValuesIntoCustomData(
      parseCookies()._ga,
      document.referrer,
      window.dataLayer
    )
      .map(customTypeDataFields => {
        return this.cartService
          .setOrderCustomTypeData(customTypeDataFields)
          .then(updatedCart => {
            sessionStorage.removeItem("gclid")
            return cartSuccess(updatedCart)
          })
          .catch(err => {
            const cartId = c?.id
            logger.error(
              `Failed to record ga data as custom type data: ${customTypeDataFields} on Cart id: ${cartId}`
            )
            Sentry.captureException(err, {
              extra: {
                commerceToolsCartId: cartId,
                commerceToolsAnonymousCartId: c?.anonymousId,
                gaData: JSON.stringify(customTypeDataFields),
                data: JSON.stringify(err?.body || {})
              }
            })
            return cartSuccess(c)
          })
      })
      .getOrElse(cartSuccess(c))
  }
}
